var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.97 309.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb275;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.65,79.87a26.58,26.58,0,0,0-1.14-16.13c-10-23.92-57.48-26.83-106-6.49s-79.66,56.21-69.63,80.13c6.31,15,27.4,21.77,54.24,19.65-10.24,24-11.51,45.15-1.35,55.25,11.34,11.27,33.93,5.78,57.61-11.72,3.7,11.61,9.53,19.62,17.08,22,18.7,5.86,40.87-25.12,49.51-69.21,4.36-22.21,4.45-43.49,1.08-59.91A40.25,40.25,0,0,0,218.65,79.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.84,110.44a19.78,19.78,0,0,0-10.19-6.33c-18.73-4.38-41.12,22.85-50,60.81s-.9,72.3,17.83,76.68c11.78,2.76,25-7,35.4-24,9.94,16.59,22.11,26.56,32.59,24.86,11.7-1.91,18.24-17.87,18-39.7,8.58,2.83,15.93,2.81,20.64-.69,11.65-8.68,2.69-35.47-20-59.85-11.44-12.27-24.18-21.59-35.51-26.71A30.06,30.06,0,0,0,504.84,110.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.28,22.59a26.61,26.61,0,0,0-13.91-8.26C229,8.93,199.56,46.24,188.61,97.67s.74,97.49,26.12,102.89c16,3.4,33.51-10.09,47.07-33.35,13.86,22.09,30.52,35.2,44.61,32.62,15.73-2.89,24.1-24.58,23.24-54,11.64,3.58,21.55,3.36,27.79-1.49,15.49-12,2.67-47.9-28.61-80.14-15.76-16.24-33.19-28.45-48.6-35A40.26,40.26,0,0,0,268.28,22.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458,50.5a26.58,26.58,0,0,0-5-15.37c-15.57-20.75-62.28-12-104.35,19.54s-63.55,73.94-48,94.69c9.78,13,31.88,14.44,57.39,5.83C354,181,357.9,201.78,370.21,209.1c13.75,8.17,34.32-2.66,53-25.41,6.42,10.36,14,16.71,21.92,17.16,19.57,1.13,33.51-34.33,31.15-79.19-1.2-22.6-6.3-43.27-13.57-58.37A40.43,40.43,0,0,0,458,50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.16,158.7s-43.74,105.52,1,149.63c0,0,77-34.61,86.37-107.25s-12-75.33-12-75.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M530.47,242.43s18.93,43.08,42.64,67.05c0,0,42.81-88.36,11.26-139.7s-56.45,10.66-56.45,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.54,153.53s292.39-284.71,378.14-48.2L514.87,157l-308.31-8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.06,50.05s28.21-103.92,92.49-12.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.16,158.7S-17,93.36,54.42,96.4,76.81,157,76.81,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.06,117.84s87.75-77.4,81.76,37.6l-44.9,25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset7);
export default __webpack_public_path__ + "static/media/Asset 7.8d8421c0.svg";
export { ForwardRef as ReactComponent };